(() => {

  'use strict';

  const tag = 'shackletons-sofa-configurator';

  const installed = Symbol.for('shackletons.buoyant.band-rules.v1');

  const isBuoyant = element => /^buoyant(?:-|$)/.test(String(element.product?.supplier_code || '').toLowerCase());

  const permits = (record, band) => !Array.isArray(record?.allowed_bands) || record.allowed_bands.some(value => String(value) === band);

  const currentBand = element => {

    const groups = element.buoyantAllGroups || element.groups || [];

    const base = groups.find(group => group.pricing_mode === 'base_band');

    const choice = base && element.choice(element.selections?.[base.group_code]);

    return element.buoyantMaterialBand || (choice?.band == null ? '' : String(choice.band));

  };

  const escape = value => String(value ?? '').replace(/[&<>"']/g, value => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[value]));

  const materialOptions = (element, originalMembers) => {

    const base = (element.buoyantAllGroups || element.groups || []).find(group => group.pricing_mode === 'base_band');

    if (!base) return [];

    const labels = element.shopify?.material_by_band || {};

    const options = new Map();

    for (const choice of originalMembers.call(element, base)) {

      const band = String(choice.band);

      const suffix = choice.name?.match(/\(([^()]*)\)\s*$/)?.[1];

      if (!options.has(band)) options.set(band, {band, name: labels[band] || suffix || `Fabric option ${band}`});

    }

    return [...options.values()].sort((a,b) => Number(a.band)-Number(b.band));

  };

  const renderMaterialChoice = (element, originalMembers) => {

    if (!element.ui || !document.createElement) return;

    const options = materialOptions(element, originalMembers);

    if (options.length <= 1) {

      element.toggleAttribute('data-buoyant-material-pending', false);

      return;

    }

    const pending = !element.buoyantMaterialBand || element.buoyantChoosingMaterial === true;

    element.toggleAttribute('data-buoyant-material-pending', pending);

    const selected = options.find(option => option.band === element.buoyantMaterialBand);

    const panel = document.createElement('section');

    panel.className = 'ssc-material-choice ssc-buoyant-material-choice';

    panel.innerHTML = `<div class="ssc-heading"><h3 class="ssc-title">Choose upholstery type</h3>${!pending && selected ? `<div class="ssc-confirmed"><span class="ssc-confirmed-name">${escape(selected.name)}</span><button type="button" class="ssc-change" data-buoyant-material-change>Change</button></div>` : ''}</div>${pending ? `<p class="ssc-instruction">Select a fabric type below to see the available fabrics.</p><div class="ssc-grid">${options.map(option => { const variant = element.baseVariant({band:option.band}); return `<div class="ssc-card"><button type="button" class="ssc-swatch ssc-material-type" data-buoyant-material="${escape(option.band)}"><span class="ssc-name">${escape(option.name)}</span>${variant ? `<span class="ssc-price">${escape(element.amount(variant.price))}</span>` : ''}</button></div>`; }).join('')}</div>` : ''}`;

    const firstStep = element.ui.querySelector('.ssc-step');

    if (firstStep) firstStep.before(panel);

    else element.ui.prepend(panel);

    if (!element.buoyantMaterialEventsBound) {

      element.buoyantMaterialEventsBound = true;

      element.addEventListener('click', event => {

        const button = event.target.closest('button');

        if (!button || !element.contains(button)) return;

        if (button.hasAttribute('data-buoyant-material')) element.chooseBuoyantMaterial(button.dataset.buoyantMaterial);

        if (button.hasAttribute('data-buoyant-material-change')) {

          element.buoyantChoosingMaterial = true;

          const base = element.baseGroup();

          if (base) { delete element.confirmed[base.group_code]; element.openGroup = base.group_code; }

          element.render();

        }

      });

      element.addEventListener('change', event => {

        if (event.target.matches('[data-mode]') && event.target.value === 'configured') {

          element.buoyantMaterialBand = '';

          element.buoyantChoosingMaterial = true;

          const base = element.baseGroup();

          if (base) {

            delete element.selections[base.group_code];

            delete element.confirmed[base.group_code];

          }

          element.render();

        }

      });

    }

  };



  customElements.whenDefined(tag).then(() => {

    const prototype = customElements.get(tag).prototype;

    if (prototype[installed]) return;

    const render = prototype.render;

    const members = prototype.members;

    const allowed = prototype.allowed;

    const blocked = prototype.blocked;

    if (![render, members, allowed].every(method => typeof method === 'function')) {

      console.error('[Buoyant configurator] Required configurator methods are unavailable.');

      return;

    }

    prototype[installed] = true;

    if (document.head && document.createElement) {

      const style = document.createElement('style');

      style.textContent = 'shackletons-sofa-configurator[data-buoyant-material-pending] .ssc-step,shackletons-sofa-configurator[data-buoyant-material-pending] .ssc-summary{display:none}.ssc-material-choice{border-bottom:1px solid #ddd;padding:20px 0;margin-bottom:20px}.ssc-material-choice .ssc-grid{grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:12px}.ssc-material-type{display:flex;min-height:94px;flex-direction:column;align-items:flex-start;justify-content:center;gap:6px;padding:14px}.ssc-material-type .ssc-name{font-size:16px;line-height:1.3}.ssc-material-type .ssc-price{font-size:14px}shackletons-sofa-configurator .ssc-buoyant-material-choice .ssc-title{font-size:28px;font-weight:700;line-height:1.25;margin:0}shackletons-sofa-configurator .ssc-buoyant-material-choice .ssc-instruction{font-size:16px;line-height:1.5;font-weight:400;color:#222;opacity:1;margin:10px 0 16px}@media(max-width:749px){shackletons-sofa-configurator .ssc-buoyant-material-choice .ssc-title{font-size:26px}shackletons-sofa-configurator .ssc-buoyant-material-choice .ssc-instruction{font-size:15px}}shackletons-sofa-configurator .ssc-buoyant-material-choice .ssc-material-type .ssc-name{font-size:18px;font-weight:600}';

      document.head.append(style);

    }



    prototype.chooseBuoyantMaterial = function (band) {

      if (!isBuoyant(this)) return;

      band = String(band);

      if (!materialOptions(this, members).some(option => option.band === band)) return;

      const base = (this.buoyantAllGroups || this.groups).find(group => group.pricing_mode === 'base_band');

      if (this.buoyantMaterialBand !== band) {

        delete this.selections[base.group_code];

        delete this.confirmed[base.group_code];

      }

      this.buoyantMaterialBand = band;

      this.buoyantChoosingMaterial = false;

      this.openGroup = base.group_code;

      this.render();

    };



    prototype.members = function (group) {

      const choices = members.call(this, group);

      if (!isBuoyant(this)) return choices;

      if (group.pricing_mode === 'base_band') return this.buoyantMaterialBand ? choices.filter(choice => String(choice.band) === this.buoyantMaterialBand) : choices;

      const band = currentBand(this);

      return band ? choices.filter(choice => permits(choice, band)) : choices;

    };



    prototype.allowed = function (group, choice) {

      if (isBuoyant(this) && group.pricing_mode !== 'base_band') {

        const band = currentBand(this);

        if (!permits(group, band) || !permits(choice, band)) return false;

      }

      return allowed.call(this, group, choice);

    };



    if (typeof blocked === 'function') prototype.blocked = function (...args) {

      if (isBuoyant(this) && this.mode === 'configured' && (!this.buoyantMaterialBand || this.buoyantChoosingMaterial === true)) return true;

      return blocked.apply(this, args);

    };



    prototype.render = function (...args) {

      if (isBuoyant(this)) this.mode = 'configured';

      if (isBuoyant(this) && this.text && /-lifestyle[._-]/i.test(this.dataset?.featuredImage || '')) {

        this.text.original_note = '';

      }

      if (isBuoyant(this) && Array.isArray(this.groups) && this.selections && this.confirmed) {

        if (this.buoyantRulesConfiguration !== this.configuration) {

          this.buoyantRulesConfiguration = this.configuration;

          this.buoyantAllGroups = this.groups.slice();

          this.buoyantMaterialBand = '';

          this.buoyantChoosingMaterial = false;

        }

        const materials = materialOptions(this, members);

        if (materials.length === 1) {

          this.buoyantMaterialBand = materials[0].band;

          this.buoyantChoosingMaterial = false;

        }

        const band = currentBand(this);

        this.groups = this.buoyantAllGroups.filter(group => permits(group, band));

        const active = new Set(this.groups.map(group => group.group_code));

        for (const group of this.buoyantAllGroups) {

          const selected = this.choice(this.selections[group.group_code]);

          if (!active.has(group.group_code) || (selected && group.pricing_mode !== 'base_band' && !permits(selected, band))) {

            delete this.selections[group.group_code];

            delete this.confirmed[group.group_code];

          }

        }

        if (this.openGroup && !active.has(this.openGroup)) this.openGroup = null;

        if (!this.openGroup) this.openGroup = this.groups.find(group => group.required !== false && !this.confirmed[group.group_code])?.group_code || null;

      }

      const result = render.apply(this, args);

      if (isBuoyant(this)) {

        const selector = this.ui?.querySelector('[data-mode]');

        if (selector) {

          for (const label of Array.from(selector.labels || [])) label.remove();

          selector.remove();

        }

        renderMaterialChoice(this, members);

      }

      return result;

    };



    document.querySelectorAll(tag).forEach(element => {

      if (isBuoyant(element) && element.ui && element.groups) element.render();

    });

  });

})();



